export default "__VITE_ASSET__BUUxNYQQ__"